import { Bookmark, Compass, House, type LucideIcon, Settings, User } from "lucide-preact";

type NavButtonProps = {
  icon: LucideIcon;
  label: string;
  href: string;
  class: string;
};

const NavButton = ({ icon: Icon, label, href, class: className }: NavButtonProps) => (
  <a href={href} class={`${className} flex flex-col items-center justify-center gap-1 flex-1 py-1.5 hover:text-neutral-700 dark:hover:text-neutral-300`}>
    <Icon class="w-6 h-6" />
    <span class="text-xs font-medium">{label}</span>
  </a>
);

export const MobileNav = () => (
  <div class="fixed bottom-0 w-full z-1000 block lg:hidden">
    <div class="flex justify-center items-center max-w-lg h-14 px-2 backdrop-blur bg-gradient-to-t from-white/95 via-white/80 to-white/60 dark:from-neutral-900/95 dark:via-neutral-900/80 dark:to-neutral-900/60 shadow-[0_-5px_10px_rgba(0,0,0,0.1)] dark:shadow-[0_-5px_10px_rgba(128,128,128,0.1)]">
      <nav class="hidden-signedin flex w-full max-w-md">
        <NavButton label="Home" icon={House} href="/" class="home-menu" />
        <NavButton label="Explore" icon={Compass} href="/articles" class="explore-menu" />
        <NavButton label="Settings" icon={Settings} href="/profile/settings" class="profile-menu" />
      </nav>
      <nav class="hidden-anonymous flex w-full max-w-md">
        <NavButton label="Home" icon={House} href="/" class="home-menu" />
        <NavButton label="Explore" icon={Compass} href="/articles" class="explore-menu" />
        <NavButton label="Collections" icon={Bookmark} href="/collections" class="collections-menu" />
        <NavButton label="Profile" icon={User} href="/profile" class="profile-menu" />
      </nav>
    </div>
  </div>
);
